module.exports = __webpack_public_path__ + "login_register_bg.f17bad44380fc5c84202.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/login_register_bg.jpg
// module id = ../../../../../src/assets/images/login_register_bg.jpg
// module chunks = styles